import script from "./LotDetailsPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotDetailsPopup.vue?vue&type=script&lang=ts&setup=true"

import "./LotDetailsPopup.vue?vue&type=style&index=0&id=5dff6139&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dff6139"]])

export default __exports__